import { Link } from 'react-router-dom';
import { categories, siteConfig } from '@/mocks/content';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="text-2xl font-heading text-background-50 tracking-tight">
              {siteConfig.name}
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed">
              {siteConfig.description}
            </p>
            <div className="flex items-center gap-4 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 text-background-100 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 text-background-100 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-700 text-background-100 hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <a href="/category/zongyi" className="hover:text-primary-400 transition-colors">频道分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              <span>更多频道</span>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5 text-sm text-foreground-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-400"></i>
                <span>support@bytv.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-primary-400"></i>
                <span>400-888-BYTV (2888)</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-400"></i>
                <span>客服时间：每天 9:00 - 21:00</span>
              </li>
            </ul>
            <div className="mt-5">
              <Link
                to="/about"
                className="text-sm text-primary-400 hover:text-primary-300 transition-colors duration-200 font-medium"
              >
                了解更多关于我们 &rarr;
              </Link>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-12 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} {siteConfig.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors" rel="nofollow">Cookie 政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}